/**
 * Homepage hero background video (sections/hero.liquid, .hero__video).
 * - Tablets and larger only: below 768px (phones) the video is never downloaded and the photo stays.
 * - The photo underneath stays visible until the first frame plays, then the video fades in over it.
 * - Skipped (the photo stays) for visitors who prefer reduced motion or when the browser refuses autoplay.
 * - Pauses while the hero is off screen or the tab is hidden, to save battery and data.
 * Resizing the window across 768px starts or stops the video accordingly.
 */
(() => {
  const videos = [...document.querySelectorAll('.hero__video')];
  if (!videos.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const phone = window.matchMedia('(max-width: 767px)');

  videos.forEach((video) => {
    if (reduce) {
      video.remove();
      return;
    }
    video.muted = true;
    let onScreen = true;
    video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });

    const update = () => {
      if (!video.isConnected) return;
      if (phone.matches || document.hidden || !onScreen) {
        video.pause();
        return;
      }
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(() => video.remove());
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          onScreen = entries.some((entry) => entry.isIntersecting);
          update();
        },
        { threshold: 0 }
      ).observe(video);
    }
    document.addEventListener('visibilitychange', update);
    phone.addEventListener('change', update);
    update();
  });
})();
